import { render } from "./NotificationTray.vue?vue&type=template&id=64f9e81a"
import script from "./NotificationTray.vue?vue&type=script&lang=js"
export * from "./NotificationTray.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__